var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportInfobg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 79,
    viewBox: "0 0 551 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_773_17145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 551,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.632812,
    width: 549,
    height: 77,
    rx: 9.5,
    fill: "#F9C836",
    stroke: "url(#paint0_linear_773_17145)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_773_17145)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-14.75 4.30469C-14.75 4.30469 159.25 126.322 303.25 48.3214C447.25 -29.6796 550.25 21.3214 550.25 21.3214V84.3214L-11.75 90.8047L-14.75 4.30469Z",
    fill: "#EA766F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M555.75 57.8029C555.75 57.8029 464.75 -11.6963 322.25 55.3036C179.75 122.303 -10.75 34.8029 -10.75 34.8029L-11.25 83.3029L555.75 82.3029V57.8029Z",
    fill: "#FA382C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_17145",
    x1: 275.25,
    y1: 0.132812,
    x2: 275.25,
    y2: 78.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD3A61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportInfobg);
export default __webpack_public_path__ + "static/media/support_infobg.14079c76c3808695d0dc6ff9d045efb4.svg";
export { ForwardRef as ReactComponent };